var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"name":"patient-filter-modal","classes":['modal-window'],"transition":"scale","scrollable":true,"adaptive":true,"reset":true,"width":"300","height":"auto"}},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-window-content"},[_c('PatientFilter')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }